module.exports = __webpack_public_path__ + "logo_fispal_tec_new.png?ad8b4311e4fe87900da2caf41cf83110";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_fispal_tec_new.png
// module id = 180
// module chunks = 0